import Alert from 'react-bootstrap/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';

const assignColor = (color) => {
  const COLORS = {
    // 'bootstrap': 'materialUI',
    'primary': 'primary',
    'secondary': 'secondary',
    'success': 'success',
    'danger': 'error',
    'warning': 'warning',
    'info': 'info',
  };

  return COLORS[color] || 'primary';
};

export const EGFlagMessage = ({
  exists = false, // show the content
  type = 'info',
  header = '',
  message = '',
  loading = false
}) => {

  if (exists) {
    return (
      <Alert key={type} variant={type} className="mx-auto">
        {header && <AlertTitle>{header}</AlertTitle>}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
          <span style={{ width: '100%' }}>{message}</span>
          {loading && <CircularProgress size={24} color={assignColor(type)} />}
        </div>
      </Alert>
    );
  }

  return <></>;
};